<template>
  <div id="login" class="c-forgot c-page">
    <div class="c-page__inner l-columns-container l-columns-container--outmost">
      <div class="l-tablet-column--4">
        <h1 class="f-headline">
          <strong>Glemt</strong> dit kodeord?
        </h1>
      </div>

      <div class="l-tablet-column--6">
        <div v-if="response" class="c-input-valid">
          <p class="c-input-valid__text">{{ response }}</p>
        </div>
        <div v-if="errorMessage" class="c-error">
          <p class="c-error__text">{{ errorMessage }}</p>
        </div>

        <form class="c-form general-form">
          <input
            v-model="input.email"
            class="c-form__element"
            type="email"
            name="email"
            placeholder="Email"
          />

          <label class="c-form__submit" @click.prevent="requestPassword()">
            <SpinnerButton
              ref="request"
              class="c-form__submit"
              cta="Nulstil kodeord"
              action="Nulstiller"
            />

            <input type="submit" value="Login" />
          </label>

          <!-- <SpinnerButton
            ref="request"
            cta="Nulstil kodeord"
            action="Nulstiller"
            class="c-form__submit"
            @clickaction="requestPassword"
          />-->

          <div class="c-secondary-nav c-login__secondary-nav">
            <router-link :to="{ path: '/opret-bruger', query: query }">Har du ikke en brugerkonto?</router-link>
            <br />
            <router-link :to="{ path: '/login', query: query }">Login?</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import SpinnerButton from "@/components/SpinnerButton.vue";

export default {
  name: "Forgot",
  components: {
    SpinnerButton
  },
  data() {
    return {
      redirect: this.$route.query.redirect || null,
      query: this.$route.query,
      errorMessage: "",
      response: "",
      input: {
        email: ""
      }
    };
  },
  methods: {
    formalValidation() {
      if (!this.input.email) {
        return {
          valid: false,
          error: "Du skal skrive din email"
        };
      }
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const validEmail = this.input.email.match(pattern);

      if (!validEmail) {
        return {
          valid: false,
          error: "Din email adresse ser ikke helt rigtig ud"
        };
      }

      return { valid: true };
    },
    requestPassword() {
      this.errorMessage = "";
      const validation = this.formalValidation();

      if (!validation.valid) {
        this.handleError(validation);
        return;
      }

      //do login
      //console.log(this.$parent)
      const obj = {
        email: this.input.email
      };
      if (this.query) {
        obj.query = this.query;
      }
      this.$userService
        .forgot(obj)
        .then(data => {
          //if (data)
          console.log(data);
          console.log(this.$userService.user);
          this.$refs.request.reset();
          this.response = `Vi har sendt en mail til ${this.input.email} med instrukser.`;
        })
        .catch(error => {
          // HAndle error
          console.log("catch", error);
          this.$refs.request.reset();
          this.handleError({
            valid: false,
            error: "Vi kan ikke genkende den email"
          });
        });
    },
    handleError(error) {
      this.$refs.request.reset();
      this.errorMessage = error.error;
      console.log(error);
    }
  }
};
</script>